import React from 'react';
import classnames from 'classnames';

import styles from './spinner.scss';

const Spinner = ({ inButton, visible }) => (
  <div className={classnames(styles.spinner, { [styles.inButton]: inButton }, { [styles.visible]: visible })}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
);

export { Spinner };


// WEBPACK FOOTER //
// ./src/elements/spinner/spinner.js